// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isAuthenticated: false,
        userName: "",
        name: "",
        accessToken: "",
    },
    mutations: {
        setAuthentication(state, status) {
            state.isAuthenticated = status;
        },
        setUserName(state, userName) {
            state.userName = userName;
        },
        setName(state, name) {
            state.name = name;
        },
        setAccessToken(state, accessToken) {
            state.accessToken = accessToken;
        },
    },
    plugins: [createPersistedState()]
});
